import { css } from '@emotion/react';
import { withPrefix } from 'gatsby-link';

import { breakpoints, colors } from '@/styles';
import { p2r, SecondaryProps } from '@/styles/fonts';

const styles = (btnIcon, btnIconHover) => css`
  padding-left: 8%;

  @media (max-width: ${breakpoints.smallTablet}px) {
    padding-left: 0;
  }

  .heroButtons {
    position: relative;
    display: flex;
    justify-content: space-between;
    margin-top: ${p2r(95)};

    @media (max-width: ${breakpoints.smallTablet}px) {
      flex-direction: column;
      gap: ${p2r(30)};
      max-width: max-content;
      margin-top: ${p2r(13)};
    }

    @media (max-width: ${breakpoints.hugeMobile}px) {
      gap: ${p2r(20)};
    }
  }

  .btn-menu {
    position: relative;
  }

  .btnIcon {
    position: relative;
    left: 1%;
    min-width: 55px;
    min-height: ${p2r(45)};
    background-image: url(${withPrefix(btnIcon)});
    transition: all 0.3s ease;
  }

  .downloadBtn-container {
    position: relative;
    z-index: 20;
    display: flex;
    gap: 40px;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    max-width: max-content;
    height: ${p2r(45)};
    padding: 0;
    cursor: pointer;
    background-color: ${colors.darkBlue};
    border: none;
    border-radius: 8px;
    transition: all 0.3s ease;

    &:hover {
      background-color: ${colors.paleBlue};
      transition: all 0.3s ease;

      .btnIcon {
        background-image: url(${withPrefix(btnIconHover)});
        transition: all 0.3s ease;
      }
    }
  }

  .btnText {
    margin: ${p2r(2)} 0 0 20px;
    ${SecondaryProps}
    font-size: ${p2r(18)};
    font-style: normal;
    font-weight: 500;
    line-height: ${p2r(40)};
    color: ${colors.white};
    text-align: left;
    letter-spacing: normal;
  }

  .btn-list {
    position: absolute;
    top: ${p2r(37)};
    right: 0;
    z-index: 15;
    width: 100%;
    min-width: max-content;
    height: max-content;
    padding: 0;
    margin: 0 0 0 14px;
    background-color: ${colors.white};
    border: 1px solid ${colors.paleGray};
    transition: all 0.5s ease;
  }

  .closed {
    & > ul {
      height: 0;
      overflow: hidden;
      opacity: 0;
      transition: all 0.5s ease;
    }
  }

  .btn-item {
    padding: ${p2r(3)} 16px 0 19px;
    ${SecondaryProps}
    font-size: ${p2r(18)};
    font-style: normal;
    font-weight: normal;
    line-height: 40px;
    color: ${colors.black};
    letter-spacing: normal;
    list-style-type: none;
    border-bottom: 1px solid ${colors.paleGray};

    &:hover {
      background-color: ${colors.darkWhite};
    }
  }

  .link-wrapper {
    color: ${colors.black};
    text-decoration: none;

    &:last-child {
      .btn-item {
        border: none;
      }
    }

    &:first-of-type {
      .btn-item {
        padding-top: ${p2r(16)};
      }
    }
  }
`;

export default styles;
